"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.CommonMedia = void 0;
var _commonMedia = _interopRequireDefault(require("./components/common-media"));
exports.CommonMedia = _commonMedia["default"];